
<template>
    <div
        :style="'position: ' + position"
        class="_affix"
    >
        <button
            class="button"
            @click="togglePosition"
        >
            Toggle Position (currently: {{ position }})
        </button>
        <pre
            v-for="(value, key) in filteredValues"
            :key="key"
        >{{ value }}<hr></pre>
    </div>
</template>

<script>
import { omit } from 'lodash';

export default {
    name: 'Affix',
    props: {
        values: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            position: localStorage.getItem('position'),
            defaultPosition: 'absolute',
            localStorageProperty: 'position'
        };
    },
    computed: {
        filteredValues() {
            var array = [];

            for (var i in this.values) {
                if (this.values[i].exclude === undefined) {
                    array.push(this.values[i].object);
                    continue;
                }

                array.push(omit(this.values[i].object, this.values[i].exclude));
            }

            return array;
        }
    },
    mounted() {
        if (this.position === null) {
            localStorage.setItem(this.localStorageProperty, this.defaultPosition);
            return this.position = this.defaultPosition;
        }
    },
    methods: {
        togglePosition() {
            this.position = this.position === 'absolute' ? 'fixed' : 'absolute';
            localStorage.setItem(this.localStorageProperty, this.position);
        }
    }
};
</script>

<style>
    ._affix {
        position: absolute;
        top: 15em;
        right: 1em;
        z-index: 2000;
        width: 40%;
        padding: 1em;
        font-size: .7em;
        background-color: #fefefe;
        border: 1px solid #d5d5d6;
    }
</style>